module.exports = __webpack_public_path__ + "img/LGOO.40bbfac7.png";